import React, { Component } from 'react';
import InShoot from '../../../assets/svg/in_shoot.svg';
import CopyPending from '../../../assets/svg/copy_pending.svg';
import VerificationPending from '../../../assets/svg/verification_pending.svg';
import ReleasePending from '../../../assets/svg/release_pending.svg';
import { type } from '@testing-library/user-event/dist/type';
import _ from 'lodash';

class MemoryCardTable extends Component {
	constructor() {
		super();
		this.state = {};
	}
	componentDidMount = () => {};
	totCount = (type, size) => {
		let tc = 0;
		if (this.props.data.length !== 0) {
			for (let i = 0; i < this.props.data.length; i++) {
				if (this.props.data[i].type === type && this.props.data[i].size === size) {
					tc += this.props.data[i].total;
				}
			}
			return tc;
		}
	};
	readyCount = (type, size) => {
		let rc = 0;
		for (let i = 0; i < this.props.data.length; i++) {
			if (this.props.data[i].type === type && this.props.data[i].size === size) {
				for (let j = 0; j < this.props.data[i].subStatusModel.length; j++) {
					if (this.props.data[i].subStatusModel[j].subStatus === 'ready') {
						rc += this.props.data[i].subStatusModel[j].subStatusCount;
					}
				}
			}
		}
		return rc;
	};
	busyCount = (type, size) => {
		let bc = 0;
		for (let i = 0; i < this.props.data.length; i++) {
			if (this.props.data[i].type === type && this.props.data[i].size === size) {
				for (let j = 0; j < this.props.data[i].subStatusModel.length; j++) {
					if (this.props.data[i].subStatusModel[j].subStatus !== 'ready') {
						bc += this.props.data[i].subStatusModel[j].subStatusCount;
					}
				}
			}
		}
		return bc;
	};
	inShootCount = (type, size) => {
		let isc = 0;
		for (let i = 0; i < this.props.data.length; i++) {
			if (this.props.data[i].type === type && this.props.data[i].size === size) {
				for (let j = 0; j < this.props.data[i].subStatusModel.length; j++) {
					if (this.props.data[i].subStatusModel[j].subStatus === 'inShoot') {
						isc += this.props.data[i].subStatusModel[j].subStatusCount;
					}
				}
			}
		}
		return isc;
	};
	copyPendingCount = (type, size) => {
		let cpc = 0;
		for (let i = 0; i < this.props.data.length; i++) {
			if (this.props.data[i].type === type && this.props.data[i].size === size) {
				for (let j = 0; j < this.props.data[i].subStatusModel.length; j++) {
					if (this.props.data[i].subStatusModel[j].subStatus === 'copyPending') {
						cpc += this.props.data[i].subStatusModel[j].subStatusCount;
					}
				}
			}
		}
		return cpc;
	};
	releasePendingCount = (type, size) => {
		let rpc = 0;
		for (let i = 0; i < this.props.data.length; i++) {
			if (this.props.data[i].type === type && this.props.data[i].size === size) {
				for (let j = 0; j < this.props.data[i].subStatusModel.length; j++) {
					if (this.props.data[i].subStatusModel[j].subStatus === 'releasePending') {
						rpc += this.props.data[i].subStatusModel[j].subStatusCount;
					}
				}
			}
		}
		return rpc;
	};
	verificationPendingCount = (type, size) => {
		let vpc = 0;
		for (let i = 0; i < this.props.data.length; i++) {
			if (this.props.data[i].type === type && this.props.data[i].size === size) {
				for (let j = 0; j < this.props.data[i].subStatusModel.length; j++) {
					if (this.props.data[i].subStatusModel[j].subStatus === 'verificationPending') {
						vpc += this.props.data[i].subStatusModel[j].subStatusCount;
					}
				}
			}
		}

		return vpc;
	};
	render() {
		return (
			<>
				<div
					className="main-bod"
					style={{
						width: '35vw',
					}}
				>
					<table
						className="memoryCardSumaryTable"
						style={{
							borderLeft: '0.5px solid  #383838',
							borderTop: '0.5px solid  #383838',
							color: 'white',
							width: '35vw',
						}}
					>
						<tr>
							<th>Model</th>
							<th>Total</th>
							<th>Ready</th>
							<th>Busy</th>
							<th>
								<img
									src={InShoot}
									alt=""
									style={{
										height: '20px',
										width: '20px',
									}}
								/>
							</th>
							<th>
								<img
									src={CopyPending}
									alt=""
									style={{
										height: '20px',
										width: '20px',
									}}
								/>
							</th>
							<th>
								{' '}
								<img
									src={VerificationPending}
									alt=""
									style={{
										height: '20px',
										width: '20px',
									}}
								/>
							</th>
							<th>
								<img
									src={ReleasePending}
									alt=""
									style={{
										height: '20px',
										width: '20px',
									}}
								/>
							</th>
						</tr>
						{_.map(
							_.orderBy(this.props.data, ['type', 'size'], ['asc', 'desc']),
							(data, key) => {
								return (
									<tr>
										<td>
											{data.type} - {data.size}
										</td>
										<td
											onClick={() =>
												this.props.handleSummaryClick(
													data.type,
													data.size,
													null,
													null,
												)
											}
										>
											{data.total}
										</td>
										<td
											style={{ color: '#479A5F' }}
											onClick={() =>
												this.props.handleSummaryClick(
													data.type,
													data.size,
													'ready',
													'ready',
												)
											}
										>
											{this.readyCount(data.type, data.size)}
										</td>
										<td
											onClick={() =>
												this.props.handleSummaryClick(
													data.type,
													data.size,
													'busy',
													null,
												)
											}
										>
											{this.busyCount(data.type, data.size)}
										</td>
										<td
											style={{ color: '#589ABB' }}
											onClick={() =>
												this.props.handleSummaryClick(
													data.type,
													data.size,
													'busy',
													'inShoot',
												)
											}
										>
											{this.inShootCount(data.type, data.size)}
										</td>
										<td
											style={{ color: '#CA4F40' }}
											onClick={() =>
												this.props.handleSummaryClick(
													data.type,
													data.size,
													'busy',
													'copyPending',
												)
											}
										>
											{this.copyPendingCount(data.type, data.size)}
										</td>
										<td
											style={{ color: '#E2793A' }}
											onClick={() =>
												this.props.handleSummaryClick(
													data.type,
													data.size,
													'busy',
													'verificationPending',
												)
											}
										>
											{this.verificationPendingCount(data.type, data.size)}
										</td>
										<td
											style={{ color: '#EBC658' }}
											onClick={() =>
												this.props.handleSummaryClick(
													data.type,
													data.size,
													'busy',
													'releasePending',
												)
											}
										>
											{this.releasePendingCount(data.type, data.size)}
										</td>
									</tr>
								);
							},
						)}
					</table>
				</div>
			</>
		);
	}
}
export default MemoryCardTable;
